export const en = {
    "symbol": "$",
    "currency":"",//币种
  }
  
  export const zh = {
    "symbol": "¥",
    "currency":"",//币种
  }